<template>
  <div class="day-filter-container">
    <div v-if="oneDay" class="label">Data:</div>
    <div v-else class="label">De:</div>

    <v-menu
      v-model="startMenuOpen"
      close-on-click
      :close-on-content-click="false"
      transition="scroll-y-transition"
      offset-y
      right
      max-width="280px"
      min-width="280px"
    >
      <template #activator="{ on }">
        <v-text-field
          v-model="startField"
          v-mask="dateMask"
          append-outer-icon="mdi-calendar"
          class="day-filter-field"
          :clearable="clearable"
          dense
          hide-details
          placeholder="nenhuma"
          @click:append-outer.stop="on.click"
          @click:clear="startField = null"
        ></v-text-field>
      </template>

      <v-date-picker
        v-model="startDate"
        no-title
        @click:date="startMenuOpen = false"
      ></v-date-picker>
    </v-menu>

    <template v-if="!oneDay">
      <div class="label">até:</div>

      <v-menu
        v-model="endMenuOpen"
        close-on-click
        :close-on-content-click="false"
        transition="scroll-y-transition"
        offset-y
        right
        max-width="280px"
        min-width="280px"
      >
        <template #activator="{ on }">
          <v-text-field
            v-model="endField"
            v-mask="dateMask"
            append-outer-icon="mdi-calendar"
            class="day-filter-field"
            :clearable="clearable"
            dense
            hide-details
            placeholder="nenhuma"
            @click:append-outer.stop="on.click"
            @click:clear="endField = null"
          ></v-text-field>
        </template>

        <v-date-picker
          v-model="endDate"
          no-title
          @click:date="endMenuOpen = false"
        ></v-date-picker>
      </v-menu>
    </template>
  </div>
</template>

<script>
import moment from "moment";
import { mapMutations } from "vuex";

export default {
  props: {
    clearable: {
      type: Boolean,
      default: false
    },
    interval: {
      type: [Array, String],
      default: () => []
    },
    oneDay: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const [startDate, endDate] = this.$store.getters.intervaloData ?? [
      null,
      null
    ];
    const [startField, endField] = [startDate, endDate].map(value =>
      this.toDate(value || "")
    );

    const dateMask = {
      mask: "##/##/####",
      tokens: {
        "#": { pattern: /\d/ }
      }
    };

    return {
      dateMask,
      endDate,
      endField,
      endMenuOpen: false,
      startDate,
      startField,
      startMenuOpen: false
    };
  },
  created() {
    this.$emit("change", this.$store.getters.intervaloData);
  },
  model: {
    prop: "interval",
    event: "change"
  },
  watch: {
    endDate(value) {
      const date = moment(value, "YYYY-MM-DD");

      if (date.isValid()) {
        const formatedDate = date.format("DD/MM/YYYY");

        if (formatedDate !== this.endField) {
          this.endField = formatedDate;
        }

        this.updateInterval();
      }
    },
    endField(value) {
      if (value === "") {
        if (this.endDate !== null) {
          this.endDate = null;
        }

        return;
      }

      const date = moment(value, ["DD/MM/YYYY", "D/M/YYYY"], true);

      if (date.isValid()) {
        const formatedDate = date.format("YYYY-MM-DD");

        if (formatedDate !== this.endDate) {
          this.endDate = formatedDate;
        }
      }
    },
    interval(value) {
      if (typeof value === "string") {
        this.startDate = value;
        this.endDate = value;
        return;
      }

      if (Array.isArray(value) && value.length === 2) {
        this.startDate = value[0];
        this.endDate = value[1];
      }
    },
    startDate(value) {
      const date = moment(value, "YYYY-MM-DD");

      if (date.isValid()) {
        const formatedDate = date.format("DD/MM/YYYY");

        if (formatedDate !== this.startField) {
          this.startField = formatedDate;
        }

        this.updateInterval();
      }
    },
    startField(value) {
      if (value === "") {
        if (this.startDate !== null) {
          this.startDate = null;
        }

        return;
      }

      const date = moment(value, ["DD/MM/YYYY", "D/M/YYYY"], true);

      if (date.isValid()) {
        const formatedDate = date.format("YYYY-MM-DD");

        if (formatedDate !== this.startDate) {
          this.startDate = formatedDate;
        }
      }
    }
  },
  methods: {
    ...mapMutations(["setIntervaloData"]),
    toDate(value) {
      return this.$options.filters.toDate(value) || null;
    },
    updateInterval() {
      if (this.oneDay) {
        this.endDate = this.startDate;
      }

      if (!this.startDate || !this.endDate) {
        return;
      }

      const nextInterval = [this.startDate, this.endDate].sort();
      [this.startDate, this.endDate] = nextInterval;

      this.setIntervaloData(nextInterval);
      this.$emit("change", nextInterval);
    }
  }
};
</script>

<style lang="scss" scoped>
.day-filter-container {
  display: flex;
  align-content: center;
  gap: 0.5rem;

  .label {
    color: #3e3e3f;
    font-size: 13px;
    font-weight: 500;
    height: 40px;
    padding-top: 9px;
  }
}

.day-filter-field::v-deep {
  margin: 0;
  padding-top: 6px;

  .v-input__control > .v-input__slot > .v-text-field__slot {
    width: 76px;

    & > input {
      color: unset !important;
      cursor: unset !important;
    }
  }
}
</style>
